// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import i18n from './libs/vuei18n.js';
import vueLoading from './libs/loadingOverlay.js';
import 'iview/dist/styles/iview.css';
import '@/css/index.less';
import http from '@/js/http.js'
import until from '@/js/until.js'
import dictionary from '@/js/dictionary.js'
import config from '@/config'
import store from './store'
import './plugins/video.js';



Vue.prototype.$http=http
Vue.prototype.$config = config
Vue.prototype.$dictionary = dictionary
Vue.prototype.$selfGlobal = {
  $globalStore: store,
  $globalI18n: i18n,
  $globalRequestMeth: {
    request: true,
    methodList: [],
  },
};
// until.phoneType()=='PC'?until.websiteAdaptive():until.adaptive()

Vue.config.productionTip = false
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});

// 全局确认对话框
let modalCon = function (text) {
  return new Promise((resolve, reject) => {
    this.$Modal.confirm({
      title: this.$i18n.tc('views.public.prompt'),
      okText: this.$i18n.tc('views.public.sure'),
      cancelText: this.$i18n.tc('views.public.cancel'),
      content: text,
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      }
    })
  })
}

// 获取权限设置
let getauth = function(id){
  let list = JSON.parse(localStorage.getItem('authList')) || [];
  let data =false;
  list.forEach((item)=>{
    if(Number(item.id)==id){
      data = item.detail_menu
    }
  })
  return data
}

Vue.prototype.$modalCon = modalCon;
Vue.prototype.getauth = getauth;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js